import { Text } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import type { EpisodeFileFormat } from "@/api";
import { hatcheryTextModes } from "@/app/theme";
import { formatBytes } from "@/utils";
import { resolveFilePreviewMode } from "./filePreviewFormat";
import { FilePreviewBody } from "./FilePreviewBody";
import styles from "../FileBrowser.module.css";

type FilePaneContentProps = {
  name: string;
  fileUuid: string;
  format: EpisodeFileFormat;
  sizeBytes: number | null;
  path: string;
  resolveUrl: () => Promise<string>;
  actions: ReactNode;
  children?: ReactNode;
};

// 파일 종류별 URL·mutation 정책은 부모에 두고, 같은 preview/meta/action 표현만 공유한다.
export function FilePaneContent({
  name,
  fileUuid,
  format,
  sizeBytes,
  path,
  resolveUrl,
  actions,
  children,
}: FilePaneContentProps): ReactNode {
  const mode = resolveFilePreviewMode(format, sizeBytes);
  // 본문을 실제로 표시할 때만 pane 을 넓힌다. 상한 초과 안내 한 줄에 72rem 을 주면 그 줄만
  // 넓게 놓인다.
  return (
    <div className={styles.filePane} data-preview={mode.kind === "text" ? "text" : undefined}>
      <FilePreviewBody name={name} fileUuid={fileUuid} mode={mode} resolveUrl={resolveUrl} />

      <dl className={styles.metaList}>
        <Meta label="형식" value={format} />
        <Meta label="크기" value={formatBytes(sizeBytes)} />
        <Meta label="경로" value={path} mono />
      </dl>

      <div className={styles.paneActions}>{actions}</div>
      {children}
    </div>
  );
}

function Meta({ label, value, mono }: { label: string; value: string; mono?: boolean }): ReactNode {
  return (
    <div className={styles.metaRow}>
      <dt className={styles.metaKey}>
        <Text variant={hatcheryTextModes["caption-normal"]}>{label}</Text>
      </dt>
      <dd className={styles.metaValue} data-mono={mono ? "true" : undefined}>
        <Text variant={hatcheryTextModes["body-normal"]}>{value}</Text>
      </dd>
    </div>
  );
}
